export default "__VITE_ASSET__68757643__"